import React, { useContext } from "react"
//import { Link } from "gatsby"
import * as Icon from "react-feather"
import { graphql, useStaticQuery } from "gatsby"
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import IQF from "../../images/siteicon/iq.svg"
import USF from "../../images/siteicon/us-4x3.svg"
import { SearchModalContext } from "../contexts/searchModalContext";

//import {useLocales} from './hook'
const query = graphql`
query {
 
  strapiSiteLogo: strapiSiteLogo {
      blackLogo {
        url
      }
    }

    strapiPublications: strapiPublications {
      Publications {
        ArabicName
        EnglishName
        UrlPage
      }
      }

      strapiRequests: strapiRequests {
  Requests {
      ArabicName
      EnglishName
      UrlPage
    }
    }
}
`




const Navbar = () => {
  const { language, languages, changeLanguage } = useI18next();
  const { openSearchModal } = useContext(SearchModalContext);
  // const {languages, originalPath, t} = useI18next();
  const handleSearchModalOpen = () => {
    openSearchModal();
  };

  const { t } = useTranslation();
  // Api query
  const data = useStaticQuery(query)
  const {
    strapiSiteLogo: { blackLogo }
  } = data
  const {
    strapiPublications: { Publications }
  } = data

  const {
    strapiRequests: { Requests }
  } = data


  // Nenu
  const [menu, setMenu] = React.useState(true)

  const toggleNavbar = () => {
    setMenu(!menu)
  }

  React.useEffect(() => {
    let elementId = document.getElementById("header")
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId.classList.add("is-sticky")
      } else {
        elementId.classList.remove("is-sticky")
      }
    })
  })

  const classOne = menu
    ? "collapse navbar-collapse"
    : "collapse navbar-collapse show"
  const classTwo = menu
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right"

  return (
    <header id="header" className="headroom navbar-style-three">
      <div className="startp-nav">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link
              to="/"
              onClick={toggleNavbar}
              className="navbar-brand"
            >
              {
                <img src={`${'https://cmsscience.nustwebsite.com'}${blackLogo.url}`}
                  alt={"blackLogo.alternativeText"} style={{ maxWidth: 75 }} />}
            </Link>

            <button
              onClick={toggleNavbar}
              className={classTwo}
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>

            <div className={classOne} id="navbarSupportedContent">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    href="https://nustwebsite.com/ar/"

                    className="nav-link"
                  >
                    {t("University")}
                  </a>
                </li>

                <li className="nav-item">
                  <Link
                    to="/"

                    className="nav-link"
                  >
                    {t("home")}
                  </Link>
                </li>


                <li className="nav-item">
                  <Link
                    to="#"
                    activeClassName="active"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    {t("AboutFaculty")} <Icon.ChevronDown />
                  </Link>
                  <ul className="dropdown-menu">


                    <li className="nav-item">
                      <Link
                        to="/about-1"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("AboutUs")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/dean-of-the-college"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("DeanshipoftheCollege")}
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        to="/academic-calendar"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("AcademicCalendar")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/instructions-and-controls"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("InstructionsAndControls")}
                      </Link>
                    </li>

                  </ul>
                </li>


                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    {t("Departments")} <Icon.ChevronDown />
                  </Link>

                  <ul className="dropdown-menu">


                    <li className="nav-item">
                      <Link
                        to="/forensic-sciences-department"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("Forensic Sciences Department")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/chemistry-department"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("Chemistry Department")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/biology-department"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                        {t("Biology Department")}
                      </Link>
                    </li>

                  </ul>
                </li>
                <li className="nav-item">
                  <Link
                    to="/college-news"

                    className="nav-link"
                  >
                    {t("LastNews")}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="/teaching-staff"

                    className="nav-link"
                  >
                    {t("TeachingStaff")}
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    {t("StudentsAffairs")} <Icon.ChevronDown />
                  </Link>

                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <Link
                        to="/student-guide"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                       {t("StudentGuide")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/top-students"
                        activeClassName="active"
                        onClick={toggleNavbar}
                        className="nav-link"
                      >
                       {t("Top students")}
                      </Link>
                    </li>
                    
                  </ul>
                </li>
                {Publications.length > 0 && <li className="nav-item">
                  <Link
                    to="#"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    {t("Publications")} <Icon.ChevronDown />
                  </Link>

                  <ul className="dropdown-menu">
                    {Publications.map((formItem) => {
                      return (
                        <li className="nav-item" key={formItem.id}>
                          <a
                            href={formItem.UrlPage}
                            activeClassName="active"
                            onClick={toggleNavbar}
                            className="nav-link"
                            target="_blank"
                          >
                            {language === "ar" ? formItem.ArabicName : formItem.EnglishName}
                          </a>
                        </li>
                      )
                    })}

                  </ul>
                </li>}
                <li className="nav-item">
                  <Link
                    to="/laboratories"

                    className="nav-link"
                  >
                    {t("laboratories")}
                  </Link>


                </li>
                {Requests.length > 0 && <li className="nav-item">
                  <Link
                    to="#"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    {t("Requests")} <Icon.ChevronDown />
                  </Link>

                  <ul className="dropdown-menu">
                    {Requests.map((formItem) => {
                      return (
                        <li className="nav-item" key={formItem.id}>
                          <a
                            href={formItem.UrlPage}
                            activeClassName="active"
                            onClick={toggleNavbar}
                            className="nav-link"
                            target="_blank"
                          >
                            {language === "ar" ? formItem.ArabicName : formItem.EnglishName}
                          </a>
                        </li>
                      )
                    })}

                  </ul>
                </li>}

                <li className="nav-item">
                  <Link
                    to="/contact"
                    activeClassName="active"
                    onClick={toggleNavbar}
                    className="nav-link"
                  >
                    {t("ContactUs")}

                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    to="#"
                    onClick={e => e.preventDefault()}
                    className="nav-link"
                  >
                    <img
                      src={language === "ar" ? IQF : USF}

                      alt={"ar"}
                    />    <Icon.ChevronDown />
                  </Link>

                  <ul className="dropdown-menu">

                    {languages.map((lng) => (
                      <li key={lng} className="nav-item">
                        <a
                          href="#"
                          className="nav-link"
                          activeClassName="active"
                          onClick={(e) => {
                            e.preventDefault();
                            changeLanguage(lng);
                          }}>
                          <img
                            src={lng === "ar" ? IQF : USF}
                            alt={"ar"}
                          /> {t(lng)}
                        </a>
                      </li>
                    ))}




                  </ul>
                </li>
              </ul>
            </div>



            <div className="others-option">

              <a className="cart-wrapper-btn facebook"
                to='#'
                onClick={() => handleSearchModalOpen()}
                onKeyDown={() => handleSearchModalOpen()}
                style={{ color: "#FFF" }} >
                <Icon.Search />

              </a>

              <Link to="/" className="btn btn-primary">
                {t("Login")}
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Navbar

/*export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;*/